<script lang="ts">
import { onMount } from "svelte";
import DBG from "../code/DBG";



    onMount(()=>{
        DBG.log("PostLogout - onMount");
        Office.onReady((info) => {
            DBG.log("StartAuth - Office onReady called", info);
            if (info.host !== Office.HostType.Project) {
                DBG.log(
                    "StartAuth - Office onReady error - not hosted in Project"
                );
                return;
            }
            setTimeout(() => {
                closeButtonClick();
            }, 1000);
        });
    });
    function closeButtonClick() {
        var messageObject = { messageType: "dialogClosed" };
        var jsonMessage = JSON.stringify(messageObject);
        Office.context.ui.messageParent(jsonMessage);
        console.log("closeButtonClick");
    } 
</script>

<div>
    POST LOGOUT
</div>